let Number_With_Commas;

Number_With_Commas = (() => {
    function Number_With_Commas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    return Number_With_Commas;
})();

export default Number_With_Commas;
